export default __webpack_public_path__ + "static/media/bg.7233529f.webp";